<template>
  <a-modal
    width="600px"
    title="拒绝任务"
    v-model:visible="visible"
    okText="拒绝"
    @ok="refuseSubmit()"
  >
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item class="set_wz" label="" name="reason">
        <a-textarea v-model:value="form.reason" placeholder="请输入拒绝原因" :rows="6"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      form: {
        reason: ''
      }
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    refuseSubmit () {
      this.$emit('submit', this.form)
    },
    close () {
      this.visible = false
    }
  }
}
</script>
<style lang="less">
.set_wz{
  div{
    margin:0 auto;
  }
}
.ant-form-item{
  margin-bottom:0;
}
</style>
